<template>
  <div class="card">
    <div class="card-body">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a
              class="nav-link active show"
              id="active-tab"
              data-toggle="tab"
              href="#currentWeek"
              role="tab"
              aria-controls="up"
              @click="selectedTab = 'currentWeek'"
          >Current Week</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              id="abandoned-tab"
              data-toggle="tab"
              href="#allTeam"
              role="tab"
              aria-controls="down"
              @click="selectedTab = 'allTeam'"
          >All Team</a
          >
        </li>
      </ul>
      <div class="tab-content customer-table">
        <div id="currentWeek" class="tab-pane active show mt-15" v-if="selectedTab === 'currentWeek'">
          <h5 class="card-title text-center font-weight-bold">Staff Shift Schedule</h5>
<!--          <div class="card leave-card">-->
<!--            <div class="row card-body">-->
<!--              <div class="col-md-4">-->
<!--                <div class="font-weight-bold fs-16 mb-10">Employees on Leave This Week</div>-->
<!--                <div v-for="(row, index) in onLeaveEmployeesInCurrentWeek" :key="index" class="mb-8">-->
<!--                  <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">-->
<!--                  <span>{{row.firstName}} {{row.lastName}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-8">-->
<!--                <div class="font-weight-bold fs-16 mb-10">Upcoming Leaves (Next 90 days)</div>-->
<!--                <div class="row">-->
<!--                  <div v-for="(row, index) in onLeaveEmployeesInNext90Days" :key="index" class="mb-8 col-md-6 row d-flex justify-content-between">-->
<!--                    <span class="col-md-6" style="width: 50%">-->
<!--                      <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">-->
<!--                      <span>{{row.firstName}} {{row.lastName}}</span>-->
<!--                    </span>-->
<!--                    <span class="text-danger col-md-6 text-right fw-600">{{groupDateRanges(row.nextLeaves)}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <perfect-scrollbar class="scroll-area">-->
            <table class="table table-bordered">
              <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-center">Sunday</th>
                <th class="text-center">Monday</th>
                <th class="text-center">Tuesday</th>
                <th class="text-center">Wednesday</th>
                <th class="text-center">Thursday</th>
                <th class="text-center">Friday</th>
                <th class="text-center">Saturday</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in makeShiftData" :key="index">
                <td class="text-center text-danger fw-600">{{ row.time }}</td>
                <td class="text-center" :class="getClass(row.sun.length, row.sun, 'Sunday', row.time)">
                  <div class="d-flex align-items-center justify-content-center">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.sun, {...row, index}, 'Sunday', true)" @mouseleave="getTitle(row.sun, {...row, index}, 'Sunday', false)" :id="'Sunday' + index" >{{row.sun.length}}</span>
                    <span v-if="getOnLeave(row.sun, 'Sunday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.sun, 'Sunday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.mon.length, row.mon, 'Monday', row.time)">
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
              <span class="make-cursor-pointer" @mouseover="getTitle(row.mon, {...row, index}, 'Monday', true)" @mouseleave="getTitle(row.mon, {...row, index}, 'Monday', false)" :id="'Monday'+index" >{{row.mon.length}}
             </span>
                    <span v-if="getOnLeave(row.mon, 'Monday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.mon, 'Monday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.tues.length, row.tues, 'Tuesday', row.time)" >
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.tues, {...row, index}, 'Tuesday', true)" @mouseleave="getTitle(row.tues, {...row, index}, 'Tuesday', false)" :id="'Tuesday'+index" >{{row.tues.length}}</span>
                    <span v-if="getOnLeave(row.tues, 'Tuesday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.tues, 'Tuesday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.wed.length, row.wed, 'Wednesday', row.time)" >
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.wed, {...row, index}, 'Wednesday', true)" @mouseleave="getTitle(row.wed, {...row, index}, 'Wednesday', false)" :id="'Wednesday'+index">{{row.wed.length}}</span>
                    <span v-if="getOnLeave(row.wed, 'Wednesday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.wed, 'Wednesday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.thurs.length, row.thurs, 'Thursday', row.time)">
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.thurs, {...row, index}, 'Thursday', true)" @mouseleave="getTitle(row.mon, {...row, index}, 'Thursday', false)" :id="'Thursday'+index" >{{row.thurs.length}}</span>
                    <span v-if="getOnLeave(row.thurs, 'Thursday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.thurs, 'Thursday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.fri.length, row.fri, 'Friday', row.time)">
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.fri, {...row, index}, 'Friday', true)" @mouseleave="getTitle(row.fri, {...row, index}, 'Friday', false)" :id="'Friday'+index">{{row.fri.length}}</span>
                    <span v-if="getOnLeave(row.fri, 'Friday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.fri, 'Friday')}}</span>
                  </div>
                </td>
                <td class="text-center" :class="getClass(row.sat.length, row.sat, 'Saturday')">
                  <div class="d-flex align-items-center justify-content-center make-cursor-pointer">
                    <span class="make-cursor-pointer" @mouseover="getTitle(row.sat, {...row, index}, 'Saturday', true)" @mouseleave="getTitle(row.sat, {...row, index}, 'Saturday', false)" :id="'Saturday'+index" >{{row.sat.length}}</span>
                    <span v-if="getOnLeave(row.sat, 'Saturday') > 0" class="badge badge-danger badge-pill mb-0 ml-4">-{{ getOnLeave(row.sat, 'Saturday')}}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
<!--          </perfect-scrollbar>-->
        </div>
        </div>
        <div id="allTeam" class="tab-pane fade" v-if="selectedTab === 'allTeam'">
          <div class="pt-20 pb-20 pr-20 pl-20">
            <h5 class="card-title text-center font-weight-bold">All Team Availability</h5>
            <div class="row d-flex justify-content-center">
              <div v-for="(row, index) in allTeamAvailability" :key="index" :class="getHighlightClass(row)" class="card team-card col-md-2 col-sm-4 col-lg-2 flex-column align-items-center mr-10 ml-10">
                <img width="100px" class="rounded-circle mr-4 mt-20" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=1200`"/>
                <span class="card-title fw-700 fs-20 mt-10 text-center">{{ row.firstName }} {{row.lastName}}</span>
                <span class="card-text">Availability:</span>
                <span class="text-danger fw-600">{{row.shifts && row.shifts[daysOfWeek[currentDay]].shiftIn ? row.shifts[daysOfWeek[currentDay]].shiftIn : 'N/A'}} {{row.shifts && row.shifts[daysOfWeek[currentDay]].shiftOut ? '- ' + row.shifts[daysOfWeek[currentDay]].shiftOut || '' : '' }}</span>
                <button @click="$router.push('/leave-management')" class="btn btn-sm btn-outline-info btn-round mb-20">View Details</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {defineComponent} from "vue";
import {db} from "@/firebase/init";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import moment from "moment";
import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import md5 from "crypto-js/md5";
import Da from "vue2-datepicker/locale/es/da";
export default defineComponent({
  components: {
    Datepicker, PerfectScrollbar
  },
  mounted() {
    this.getCurrentWeekDates()
    this.getAdminShifts()
  },
  props: {
    dateTime: {
      type: String
    }
  },
  data() {
    return {
      selectedTab: 'currentWeek',
      currentDay: new Date().getDay(),
      weekDates: [],
      filterWeeksDates: [],
      allShifts: [],
      estTime: [
        { time: "00:00" },
        { time: "01:00" },
        { time: "02:00" },
        { time: "03:00" },
        { time: "04:00" },
        { time: "05:00" },
        { time: "06:00" },
        { time: "07:00" },
        { time: "08:00" },
        { time: "09:00" },
        { time: "10:00" },
        { time: "11:00" },
        { time: "12:00" },
        { time: "13:00" },
        { time: "14:00" },
        { time: "15:00" },
        { time: "16:00" },
        { time: "17:00" },
        { time: "18:00" },
        { time: "19:00" },
        { time: "20:00" },
        { time: "21:00" },
        { time: "22:00" },
        { time: "23:00" },
      ],
      daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      septemEmails: ['umair.raza@septemsystems.com', 'abdul.hannan@septemsystems.com', 'asma.naz@septemsystems.com', 'mahnoor.feroz@septemsystems.com', 'salman.yousaf@septemsystems.com', 'sabee.rehman@septemsystems.com']
    }
  },
  computed: {
    allTeamAvailability() {
      let array = this.allShifts
      array = [...this.allShifts.filter(el => el.shifts && el.shifts[this.daysOfWeek[this.currentDay]].shiftIn <= this.dateTime && ((el.shifts[this.daysOfWeek[this.currentDay]].shiftOut <= this.dateTime && el.shifts[this.daysOfWeek[this.currentDay]].daySelection === 'nextDay') || (el.shifts[this.daysOfWeek[this.currentDay]].shiftOut >= this.dateTime && el.shifts[this.daysOfWeek[this.currentDay]].daySelection === 'sameDay'))), ...this.allShifts.filter(el => !(el.shifts && el.shifts[this.daysOfWeek[this.currentDay]].shiftIn <= this.dateTime && ((el.shifts[this.daysOfWeek[this.currentDay]].shiftOut <= this.dateTime && el.shifts[this.daysOfWeek[this.currentDay]].daySelection === 'nextDay') || (el.shifts[this.daysOfWeek[this.currentDay]].shiftOut >= this.dateTime && el.shifts[this.daysOfWeek[this.currentDay]].daySelection === 'sameDay'))))];
      return array
    },
    onLeaveEmployeesInCurrentWeek() {
      return this.modifiedShifts.filter(el => el.shifts && !!Object.values(el.shifts).find(el1 => el1.onLeave))
    },
    onLeaveEmployeesInNext90Days() {
      const today = new Date();
      const modifiedToday = moment(today).format("MMM D, YYYY");
      console.log(modifiedToday)
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + 90);
      const modifiedFuture = moment(futureDate).format("MMM D, YYYY");
      let array = []
      array = this.allShifts.filter(el => {
        if(el.leave) {
          el.nextLeaves = el.leave.filter(leave => new Date(leave) > new Date(modifiedToday) && new Date(leave) <= new Date(modifiedFuture))
        }
        el.nextLeaves = el.nextLeaves.sort((a, b) => new Date(a) - new Date(b))
        if(el.nextLeaves.length) {
          return true;
        }
        return false;
      })
      console.log('shift array at 225', array)
      return array
    },
    modifiedShifts() {
      const today = new Date();
      const array = []
      this.allShifts.map(el => {
        if(el.leave && el.leave.length) {
          el.leave.map(el2 => {
            if(this.weekDates.includes(el2) && el2 >= moment(today).format('MMM D, YYYY')) {
              const date = new Date(el2);
              const day = date.getDay();
              console.log('elllll', el, day)
              el.shifts[this.daysOfWeek[day]].onLeave = true;
            }
          })
          array.push(el)
        } else {
          array.push(el)
        }
      })
      console.log('shift array', array.find(el => el.email === 'ahmad@bigscoots.com'))
      return array
    },
    makeShiftData() {
      const arr = this.estTime.map(el => {
        el.sat = this.modifiedShifts.filter(el2 => el2.shifts['Saturday'] && el2.shifts['Saturday'].shiftIn <= el.time && ((el2.shifts['Saturday'].shiftOut >= el.time && el2.shifts['Saturday'].daySelection === 'sameDay') || (el2.shifts['Saturday'].shiftOut <= el.time && el2.shifts['Saturday'].daySelection === 'nextDay')))
        el.sun = this.modifiedShifts.filter(el2 => el2.shifts['Sunday'] && el2.shifts['Sunday'].shiftIn <= el.time && ((el2.shifts['Sunday'].shiftOut >= el.time && el2.shifts['Sunday'].daySelection === 'sameDay') || (el2.shifts['Sunday'].shiftOut <= el.time && el2.shifts['Sunday'].daySelection === 'nextDay')))
        el.mon = this.modifiedShifts.filter(el2 => el2.shifts['Monday'] && el2.shifts['Monday'].shiftIn <= el.time && ((el2.shifts['Monday'].shiftOut >= el.time  && el2.shifts['Monday'].daySelection === 'sameDay') || (el2.shifts['Monday'].shiftOut <= el.time && el2.shifts['Monday'].daySelection === 'nextDay')))
        el.tues = this.modifiedShifts.filter(el2 => el2.shifts['Tuesday'] && el2.shifts['Tuesday'].shiftIn <= el.time && ((el2.shifts['Tuesday'].shiftOut >= el.time && el2.shifts['Tuesday'].daySelection === 'sameDay') || (el2.shifts['Tuesday'].shiftOut <= el.time && el2.shifts['Tuesday'].daySelection === 'nextDay')))
        el.wed = this.modifiedShifts.filter(el2 => el2.shifts['Wednesday'] && el2.shifts['Wednesday'].shiftIn <= el.time && ((el2.shifts['Wednesday'].shiftOut >= el.time && el2.shifts['Wednesday'].daySelection === 'sameDay') || (el2.shifts['Wednesday'].shiftOut <= el.time && el2.shifts['Wednesday'].daySelection === 'nextDay')))
        el.thurs = this.modifiedShifts.filter(el2 => el2.shifts['Thursday'] && el2.shifts['Thursday'].shiftIn <= el.time && ((el2.shifts['Thursday'].shiftOut >= el.time && el2.shifts['Thursday'].daySelection === 'sameDay') || (el2.shifts['Thursday'].shiftOut <= el.time && el2.shifts['Thursday'].daySelection === 'nextDay')))
        el.fri = this.modifiedShifts.filter(el2 => el2.shifts['Friday'] && el2.shifts['Friday'].shiftIn <= el.time && ((el2.shifts['Friday'].shiftOut >= el.time && el2.shifts['Friday'].daySelection === 'sameDay') || (el2.shifts['Friday'].shiftOut <= el.time && el2.shifts['Friday'].daySelection === 'nextDay')))
        return el;
      })
      return arr
    }
  },
  watch: {
    makeShiftData(val) {
      this.renderDatatable()
    }
  },
  methods: {
    getHighlightClass(row) {
      const currentDay = row.shifts ? row.shifts[this.daysOfWeek[this.currentDay]] : {}
      console.log('currentDay', currentDay)
      if(currentDay.shiftIn) {
        console.log('279', currentDay.shiftIn <= this.dateTime)
        return currentDay.shiftIn <= this.dateTime && ((currentDay.shiftOut >= this.dateTime && currentDay.daySelection === 'sameDay') || (currentDay.shiftOut <= this.dateTime && currentDay.daySelection === 'netDay')) ? 'light-green' : ''
      }
    },
    groupDateRanges(dates) {
      // Convert string dates to Date objects and sort them
      let dateObjects = dates.map(date => new Date(date)).sort((a, b) => a - b);

      let result = [];
      let start = dateObjects[0];
      let end = dateObjects[0];

      for (let i = 1; i < dateObjects.length; i++) {
        let currentDate = dateObjects[i];
        let previousDate = new Date(end);
        previousDate.setDate(previousDate.getDate() + 1); // Get next consecutive date

        if (currentDate.getTime() === previousDate.getTime()) {
          // If consecutive, update the range end
          end = currentDate;
        } else {
          // Push the formatted range and reset start & end
          result.push(this.formatRange(start, end));
          start = currentDate;
          end = currentDate;
        }
      }

      // Push the last processed range or single date
      result.push(this.formatRange(start, end));

      return result.join(', ');
    },

    // Helper function to format date ranges
    formatRange(start, end) {
      const options = { month: "short", day: "2-digit", year: "numeric" };
      const startStr = start.toLocaleDateString("en-US", options);
      const endStr = end.toLocaleDateString("en-US", options);
      return startStr === endStr ? startStr.split(',')[0] : `${startStr.split(',')[0]} - ${endStr.split(',')[0]}`;
    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    getCurrentWeekDates() {
      let today = new Date();

      // Set to the current date's time (to avoid any time difference when comparing)
      today.setHours(0, 0, 0, 0);

      // Get the current day of the week (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
      let dayOfWeek = today.getDay();

      // Calculate the difference between today and the start of the week (Monday)
      let diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust if today is Sunday (get -6 days back)

      // Get the date of Monday (start of the current week)
      let monday = new Date(today);
      monday.setDate(today.getDate() + diffToMonday);

      // Store the dates of the current week (Monday to Sunday)
      for (let i = 0; i < 7; i++) {
        let date = new Date(monday);
        date.setDate(monday.getDate() + i);
        this.weekDates.push(moment(date).format('MMM D, YYYY')); // or use toISOString(), or any other date format
        if(i ===0 || i === 6){
          this.filterWeeksDates.push(date.toISOString()); // or use toISOString(), or any other date format
        }
      }

    },
    async getAdminShifts() {
      const ref = await db.collection("admin-shifts").get();
      if(ref.size) {
        ref.forEach(el => {
          this.allShifts.push({id: el.id, ...el.data()})
        })
        this.allShifts = this.allShifts.filter(el => !this.septemEmails.includes(el.email));
      }
    },
    getOnLeave(array, day) {
      return array.filter(el => el.shifts[day].onLeave).length
    },
    getTitle(array, fullRow, day, flag) {
      if(!flag || !array.length) {
        return true
      }
      let title = `<div class="p-2"><h6 class="text-center">Staff at ${fullRow.time} EST</h6>`;
      for(const row of array) {
        console.log('rowww', row)
        title += `<span><b>${row.firstName} ${row.lastName}:</b> <span>${row.shifts[day].shiftIn} EST`;
        if(row.shifts[day].shiftOut) {
          title += `- ${row.shifts[day].shiftOut || ''} EST`
          if(row.shifts[day].daySelection === 'nextDay') {
            title += `(Next Day)`
          }
        }
        if(row.shifts[day].onLeave) {
          title += '<span class="badge badge-danger ml-5 fs-8 pt-0 pb-0 mt-6">Leave</span>'
        }
        title+= `</span></span><br>`
      }
      title += `</div>`
      console.log('title', title)
      tippy(`#${day}${fullRow.index}`, {
        content: flag ? title : '',
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    renderDatatable() {
      console.log('rendering')
      if($.fn.DataTable.isDataTable('#datatble')) {
        $(`#datatble`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#datatble`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
          "ordering": false,
        });
      }, 0)
    },
    getClass(count, array, day, time) {
      let className = '';
      console.log('array', array)
      const obj = array.find(el=> el.shifts[day].onLeave)
      // console.log('on leave at 150', obj)
      if(count === 0) {
        className = 'no-coverage'
      } else if(count <=2) {
        if(obj) {
          className = 'yellow-with-leaves'
        } else {
          className = 'yellow'
        }
      } else if(count <= 4) {
        if(obj) {
          className = 'light-green-with-leaves'
        } else {
          className = 'light-green'
        }
      } else if(count >= 5) {
        if(obj) {
          className = 'ultra-green-with-leaves'
        } else {
          className = 'ultra-green'
        }
      }
      if(time && this.daysOfWeek[this.currentDay] === day) {
        const timeNow  = this.dateTime ?  this.dateTime.split(':') : ''
        const timeFromTable = time.split(':')
        console.log('273', timeNow, timeFromTable)
        if(timeNow[0] === timeFromTable[0]) {
          if(timeNow[1] >= timeFromTable[1]) {
            className += ' highlight-time'
          }
        }
      }
      return className
    }
  }
})
</script>

<style scoped>
.yellow{
  background: #FEF2C7 !important;
}
.no-coverage{
  background: #FDE2E1;
}
.light-green {
  background: #D1FAE4 !important;
}
.ultra-green {
  background: #33ff002e;
}
.yellow-with-leaves{
  background: #FEF2C7;
  //background-image: linear-gradient(50deg, #FEF2C7 26%, #FDE2E1 40%, #FDE2E1 60%, #FEF2C7 75%);
}.light-green-with-leaves{
   background: #D1FAE4;
  //background-image: linear-gradient(50deg, #D1FAE4 26%, #FDE2E1 40%, #FDE2E1 60%, #D1FAE4 75%);
}.ultra-green-with-leaves{
    background: #33ff002e;
  }
.circle{
  padding: 10px 15px 10px 15px;
  margin: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 50%;
}
.highlight-time {
  border: 3px solid #ffb700b3;
}
.leave-card{
  background: #b7e1eea6;
  padding: 10px;
}
.scroll-area {
  //position: relative;
  //max-height: 600px;
  //overflow: hidden;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.team-card{
  background: #F9F9F9;
  border: 0.3px solid #DDDDDD
}
</style>